import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  dataLayerGA4ChatToFitter,
  dataLayerGA4UserSize,
  dataLayerGA4TimeOnQuizStage,
} from '../../shared/utils/data-layer.js';

// Control Buttons
export const Next = ({
  backSize,
  cupSize,
  disabled,
  customFunc,
  resetSelected,
  stageNumber,
  setStageNumber,
  text,
  hasChevron,
  id,
  locale,
}) => {
  const [startTime, setStartTime] = useState(0);

  useEffect(() => {
    setStartTime(Date.now());
  }, []);

  return (
    <button
      id={id}
      className={disabled ? 'disabled controlButton' : 'show controlButton'}
      onClick={() => {
        const elapsedTimeOnQuizStage = (Date.now() - startTime) / 1000;

        dataLayerGA4TimeOnQuizStage(stageNumber, elapsedTimeOnQuizStage);

        if (disabled) {
          return;
        }
        if (stageNumber === 1) {
          dataLayerGA4UserSize(stageNumber, backSize, cupSize);
        }
        resetSelected(0);
        // If cupSize is undefined or no cup size is found, then cupsize is outside of limits
        // so take user to "We're Sorry" page at end of quiz
        if (stageNumber > 1 && cupSize === 'No size found') {
          // Set to large enough number to ensure 'default' switch case is selected
          setStageNumber(100);
          return;
        }
        // If the cupSize is M,N or O, then size is not stocked, so take the user to "We're Sorry" page at end of quiz
        if (
          locale === 'en-GB' &&
          stageNumber > 9 &&
          /^([M-Z])$/.test(cupSize)
        ) {
          // Set to large enough number to ensure 'default' switch case is selected
          setStageNumber(100);
          return;
        }
        if (
          locale === 'en-US' &&
          stageNumber > 9 &&
          /^([R-Z])$/.test(cupSize)
        ) {
          setStageNumber(100);
          return;
        }
        if (customFunc) {
          customFunc();
          setStageNumber();
          return;
        }

        setStageNumber();
      }}
    >
      {hasChevron ? `${text} ${String.fromCharCode(10095)}` : text}
    </button>
  );
};

export const Back = ({
  setStageNumber,
  customFunc,
  resetSelected,
  text,
  isThirdWidth,
}) => {
  return (
    <button
      className={`back ${isThirdWidth ? 'back--thirdWidth' : ''}`}
      onClick={() => {
        resetSelected(0);
        setStageNumber();

        if (customFunc) {
          customFunc();
        }
      }}
    >
      <span className="buttonLabel">{`${String.fromCharCode(
        10094
      )} ${text}`}</span>
    </button>
  );
};

export const ChatToAFitter = ({ stage }) => {
  return (
    <button
      className="chatToAFitter"
      onClick={() => {
        dataLayerGA4ChatToFitter(stage);
        window.location.href = `${window.location.protocol}//${
          window.location.host
        }${
          window.location.href.indexOf('/us/') > -1
            ? '/us/live-chat'
            : '/live-chat'
        }`;
      }}
    >
      chat to a fitter
    </button>
  );
};

Back.propTypes = {
  text: PropTypes.string,
  setStageNumber: PropTypes.func,
  customFunc: PropTypes.func,
  resetSelected: PropTypes.func,
  isThirdWidth: PropTypes.bool,
};

Next.propTypes = {
  backSize: PropTypes.string,
  cupSize: PropTypes.string,
  customFunc: PropTypes.func,
  disabled: PropTypes.bool,
  resetSelected: PropTypes.func,
  setStageNumber: PropTypes.func,
  stageNumber: PropTypes.number,
  text: PropTypes.string,
  hasChevron: PropTypes.bool,
  id: PropTypes.string,
  locale: PropTypes.string,
};

ChatToAFitter.propTypes = {
  stage: PropTypes.number,
};
